import React, { useCallback, useState } from "react";

import rondloper from "./assets/audio/rondloper.mp3";
import Controls from "./components/Controls";
import ControlsContainer from "./components/ControlsContainer";
import Game from "./components/Game";
import GameIntro from "./components/GameIntro";
import IntroLastFrame from "./components/IntroLastFrame";

const App = () => {
  const [isGamePlaying, setIsGamePlaying] = useState(false);
  const [isBgMusicMuted, setIsBgMusicMuted] = useState(false);
  const [canPlayBgMusic, setCanPlayBgMusic] = useState(false);
  const bgMusicRef: React.MutableRefObject<HTMLAudioElement | null> =
    React.createRef();

  const [gameSession, setGameSession] = useState(0);

  const quitGame = () => {
    setGameSession((prevState) => prevState + 1);
    setIsGamePlaying(false);
    setCanPlayBgMusic(false);
  };

  const startBgMusic = () => {
    if (bgMusicRef?.current) {
      // Formerly muted, so start from beginning
      bgMusicRef.current.currentTime = 0;
      bgMusicRef.current.volume = 0.35;
    }
    setCanPlayBgMusic(true);
  };

  const toggleMute = () => {
    setIsBgMusicMuted((prevState) => !prevState);
  };

  const onEndIntro = useCallback(() => {
    setIsGamePlaying(true);
  }, []);

  return (
    <>
      <audio
        src={rondloper}
        autoPlay
        loop
        ref={bgMusicRef}
        muted={!canPlayBgMusic}
      />

      {/* Always keep the last frame in background for a smooth transition between intro and game */}
      <IntroLastFrame />
      {isGamePlaying ? (
        <>
          <Game
            key={gameSession}
            isMuted={isBgMusicMuted}
            bgMusicRef={bgMusicRef}
          />
          <ControlsContainer>
            <Controls
              isBgMusicMuted={isBgMusicMuted}
              toggleMute={toggleMute}
              quitGame={quitGame}
            />
          </ControlsContainer>
        </>
      ) : (
        <GameIntro
          onEndIntro={onEndIntro}
          key={gameSession}
          onStartInstructions={startBgMusic}
        />
      )}
    </>
  );
};

export default App;
